import * as React from 'react'
import { useSocketService } from '../../context/SocketServiceContext'
import { default as ReactAvatar } from 'react-avatar'
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-duotone-svg-icons/faCircle'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const logo = require('../../images/xlab-logo.jpg')

import Kedo from '../../Kedo.js'

interface IAvatarOptions {
    togglePresence?: boolean
    size?: any
    showPresence?: boolean
}

type Props = {
    kedo: Kedo
    user: any
    props: any
    onClick?: any
    options?: IAvatarOptions
}

const Avatar = ({ kedo, user, props, onClick, options }: Props) => {
    const socketService = useSocketService()

    // ✅ merge defaults (replaces defaultProps)
    const mergedOptions: IAvatarOptions = {
        size: 35,
        showPresence: true,
        ...options,
    }

    const [status, setStatus] = useState('')
    const [toggle, setToggle] = useState(false)
    const [avatar, setAvatar] = useState('')

    useEffect(() => {
        if (mergedOptions.togglePresence) {
            kedo.api()
                .get(kedo.api().getUserProfileEndpoint('me'))
                .then((result) => {
                    const presence = result.data?.private_settings?.presence

                    if (presence) {
                        socketService.user
                            .setPresence(presence)
                            .then((resultPresence) => {
                                setStatus(resultPresence)
                                setToggle(false)
                            })
                    }
                })
                .catch((errResponse) => console.log(errResponse))
        }
    }, [kedo, socketService, mergedOptions.togglePresence])

    useEffect(() => {
        if (!user?.userId) return
        setStatus(socketService.user.getPresence(user.userId))
    }, [socketService, user?.userId])

    const handleOnClick = (e) => {
        if (e?.stopPropagation) e.stopPropagation()

        if (!onClick && !mergedOptions.togglePresence) {
            props.history.push('/user/' + user.userId)
        } else if (!onClick && mergedOptions.togglePresence) {
            setToggle((prev) => !prev)
        } else if (onClick) {
            onClick()
        }
    }

    const setPresence = (e, presence) => {
        if (e?.stopPropagation) e.stopPropagation()

        const userData = {
            private_settings: { presence },
        }

        kedo.api()
            .patch(kedo.api().getUserProfileEndpoint('me'), userData)
            .then(() => {
                socketService.user
                    .setPresence(presence)
                    .then((resultPresence) => {
                        setStatus(resultPresence)
                        setToggle(false)
                    })
            })
            .catch((errResponse) => console.log(errResponse))
    }

    const presenceColor = (presence) => {
        switch (presence) {
            case 'online':
                return 'green'
            case 'busy':
                return 'red'
            case 'away':
                return 'orange'
            default:
                return 'unset'
        }
    }

    const fetchAvatar = () => {
        if (!user?.userId) return

        kedo.api()
            .getCached(kedo.api().getUserEndpoint(user.userId))
            .then((response) => {
                setAvatar(
                    response.data?.avatar?.length > 0
                        ? kedo
                              .api()
                              .getUserAvatarEndpoint(
                                  user.userId,
                                  response.data.avatar
                              )
                        : null
                )
            })
    }

    useEffect(() => {
        fetchAvatar()
    }, [user?.userId, kedo])

    return (
        <>
            <div className="avatar-online" onClick={handleOnClick}>
                <ReactAvatar
                    name={`${user?.username}`}
                    round={true}
                    value="40%"
                    size={mergedOptions.size}
                    src={avatar || (!user?.username ? logo : null)}
                />

                {mergedOptions.showPresence && kedo.env()?.hasEnviroment() ? (
                    <FontAwesomeIcon
                        style={{
                            color: presenceColor(status),
                            top: mergedOptions.size <= 26 ? '16px' : '22px',
                            left: mergedOptions.size <= 26 ? '16px' : '22px',
                        }}
                        icon={faCircle}
                    />
                ) : null}
            </div>

            {mergedOptions.togglePresence && toggle ? (
                <div
                    style={{ display: 'block', fontSize: '14px' }}
                    className="dropdown-menu"
                >
                    <a
                        onClick={(e) => setPresence(e, 'online')}
                        className="dropdown-item"
                    >
                        <FontAwesomeIcon
                            style={{ color: 'green' }}
                            icon={faCircle}
                        />{' '}
                        Online
                    </a>

                    <a
                        onClick={(e) => setPresence(e, 'away')}
                        className="dropdown-item"
                    >
                        <FontAwesomeIcon
                            style={{ color: 'orange' }}
                            icon={faCircle}
                        />{' '}
                        Away
                    </a>

                    <a
                        onClick={(e) => setPresence(e, 'busy')}
                        className="dropdown-item"
                    >
                        <FontAwesomeIcon
                            style={{ color: 'red' }}
                            icon={faCircle}
                        />{' '}
                        Busy
                    </a>

                    <div className="dropdown-divider" />

                    <a
                        onClick={(e) => setPresence(e, 'invisible')}
                        className="dropdown-item"
                    >
                        <FontAwesomeIcon icon={faCircle} /> Invisible
                    </a>
                </div>
            ) : null}
        </>
    )
}

export default Avatar
